























































import { Component, Vue, Prop } from "vue-property-decorator";
import { IMember } from "@/models/Member.model";

@Component
export default class MemberCard extends Vue {
  @Prop()
  member!: IMember;

  displayModal = false;

  displayBio() {
    this.displayModal = true;
  }
  closeBio() {
    this.displayModal = false;
  }
}
